export default {
  docId: null,
  docPageId: null,
  roomDocFiles: [],
  roomGroupId: 'default',
  roomGroups: {},
  uploadRoomDocFiles: [],
  allowedFileExts: '.pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.bmp,.hwp',
  // JMT
  chosenDocFile: {
    pages: []
  },
  isOpenDocFileList: true,
}
